<template>
  <div class="hero is-fullheight fullpage-section" data-anchor="section-dyp">
    <div
      class="height109"
      v-bind:class="{ 'orange-background': indexdev === 4 }"
    >
      <div class="column is-hidden-mobile is-hidden-tablet-only">
        <div class="column is-hidden-mobile"></div>
      </div>
      <div
        class="column"
        align="center"
        v-on:click="(indexdev = 0), (nameIndex = 3)"
      >
        <h2
          class="column title-full-size has-font-unicone dp-title"
          align="center"
          v-bind:class="{
            'is-size-4': indexdev === 0 || indexdev === 5,
            'text-transparent': indexdev === 4,
            'is-paddingless': indexdev === 5,
            'is-hidden-landscape': nameIndex !== 3
          }"
        >
          DESARROLLO <br />
          Y PRODUCCIÓN
        </h2>
        <h2
          class="column has-font-unicone dp-title is-hidden-desktop is-hidden-portrait is-hidden-landscape"
          align="center"
          v-bind:class="{
            'is-size-2': indexdev === 4,
            'is-paddingless': indexdev === 4,
            'display-inherit-in-landscape': nameIndex === 0,
            'is-hidden-touch': nameIndex !== 0
          }"
        >
          DESARROLLO <br />
          SOFTWARE
        </h2>
        <h2
          class="column has-font-unicone dp-title is-hidden-desktop is-hidden-portrait is-hidden-landscape"
          align="center"
          v-bind:class="{
            'is-size-2': indexdev === 4,
            'is-paddingless': indexdev === 4,
            'display-inherit-in-landscape': nameIndex === 1,
            'is-hidden-touch': nameIndex !== 1
          }"
        >
          IMPRESIÓN <br />
          3D
        </h2>
        <h2
          class="column has-font-unicone dp-title is-hidden-desktop is-hidden-portrait is-hidden-landscape"
          align="center"
          v-bind:class="{
            'is-size-2': indexdev === 4,
            'is-paddingless': indexdev === 4,
            'display-inherit-in-landscape': nameIndex === 2,
            'is-hidden-touch': nameIndex !== 2
          }"
        >
          TESTEO DE <br />
          MATERIAL
        </h2>
        <p
          align="center"
          v-bind:class="{
            'text-transparent': indexdev === 4,
            'is-hidden-landscape': nameIndex !== 3
          }"
        >
          En Calce desarrollamos e integramos tecnología aplicable en los
          procesos de rehabilitación de nuestros clientes y usuarios.
          <br class="is-hidden-mobile" />
          Buscamos innovar de forma constante, alcanzando los más estándares
          internacionales de calidad.
        </p>
        <p
          class="is-hidden-landscape is-hidden-portrait is-hidden-desktop"
          align="center"
          v-bind:class="{
            'display-inline-in-landscape': nameIndex === 0,
            'is-hidden-touch': nameIndex !== 0
          }"
        >
          <strong>Creamos y mantenemos</strong> herramientas que
          <strong> simplifican</strong> <br />
          los procedimientos médicos necesarios para la fabricación de
          <strong> nuestros productos.</strong>
        </p>
        <p
          class="is-hidden-landscape is-hidden-portrait is-hidden-desktop"
          align="center"
          v-bind:class="{
            'display-inline-in-landscape': nameIndex === 1,
            'is-hidden-touch': nameIndex !== 1
          }"
        >
          <strong>Desarrollamos </strong> productos finales utilizando
          <strong> impresoras</strong> de bajo costo,<br />
          gracias a <strong> nuestra expertiz</strong> en resistencia de
          materiales y métodos de impresión.
        </p>
        <p
          class="is-hidden-landscape is-hidden-desktop is-hidden-portrait"
          align="center"
          v-bind:class="{
            'display-inline-in-landscape': nameIndex === 2,
            'is-hidden-touch': nameIndex !== 2
          }"
        >
          <strong>Testeamos</strong> nuestros materiales
          <strong>basados</strong> en las normas: <strong>ASTMD-790</strong> de
          resistencia a la <strong>flexión</strong> y
          <strong>ASTMD-7774-17</strong> de resistencia a la
          <strong>fatiga.</strong>
        </p>
      </div>

      <div class="column height10 is-hidden-mobile"></div>
      <div
        class="columns display-flex-in-landscape is-hidden-portrait  is-centered"
      >
        <div
          class="column is-one-fifth is-3-mobile"
          v-bind:class="{ 'new-back': nameIndex === 2 }"
        >
          <h2
            class="column is-size-2 is-hidden-touch has-font-unicone dp-title full-center"
            align="center"
            v-bind:class="{
              'is-hidden': nameIndex === 0 || nameIndex === 2 || nameIndex === 3
            }"
          >
            <br />
            IMPRESIÓN <br />
            3D
          </h2>
          <p
            class="is-hidden-touch position-center"
            align="center"
            v-bind:class="{
              'is-hidden': nameIndex === 0 || nameIndex === 1 || nameIndex === 3
            }"
          >
            <br />
            <strong>Testeamos</strong> <br />
            nuestros materiales <br />
            <strong>basados</strong> en las normas: <br />
            <strong>ASTMD-790</strong> de <br />
            resistencia a la <strong>flexión</strong> y <br />
            <strong>ASTMD-7774-17</strong> de <br />
            resistencia a la <strong>fatiga.</strong>
          </p>
          <img
            v-on:click="(indexdev = 4), (nameIndex = 0)"
            v-on:mouseover="(indexdev = 4), (nameIndex = 0)"
            v-on:mouseout="(indexdev = 0), (nameIndex = 3)"
            :src="productoActualImg(0)"
            alt=""
            v-bind:class="{ 'is-hidden': nameIndex === 1 || nameIndex === 2 }"
          />
        </div>

        <div class="column is-one-fifth is-3-mobile">
          <h2
            class="column is-size-2 is-hidden-touch has-font-unicone dp-title full-center"
            align="center"
            v-bind:class="{
              'is-hidden': nameIndex === 1 || nameIndex === 2 || nameIndex === 3
            }"
          >
            <br />
            DESARROLLO <br />
            SOFTWARE
          </h2>
          <h2
            class="column is-size-2 is-hidden-touch has-font-unicone dp-title full-center"
            align="center"
            v-bind:class="{
              'is-hidden': nameIndex === 0 || nameIndex === 1 || nameIndex === 3
            }"
          >
            <br />
            TESTEO DE <br />
            MATERIAL
          </h2>
          <img
            v-on:click="(indexdev = 4), (nameIndex = 1)"
            v-on:mouseover="(indexdev = 4), (nameIndex = 1)"
            v-on:mouseout="(indexdev = 0), (nameIndex = 3)"
            :src="productoActualImg(1)"
            alt=""
            v-bind:class="{ 'is-hidden': nameIndex === 0 || nameIndex === 2 }"
          />
        </div>
        <div
          class="column is-one-fifth is-3-mobile"
          v-bind:class="{ 'new-back': nameIndex === 0 || nameIndex === 1 }"
        >
          <p
            class="is-hidden-touch position-center"
            align="center"
            v-bind:class="{
              'is-hidden': nameIndex === 1 || nameIndex === 2 || nameIndex === 3
            }"
          >
            <br /><br />
            <strong>
              Creamos y <br />
              mantenemos
            </strong>
            herramientas<br />
            que <strong>simplifican</strong> los <br />
            procedimientos médicos <br />
            necesarios para la fabricación <br />
            de <strong>nuestros productos.</strong>
          </p>
          <p
            class="is-hidden-touch position-center"
            align="center"
            v-bind:class="{
              'is-hidden': nameIndex === 0 || nameIndex === 2 || nameIndex === 3
            }"
          >
            <br />
            <strong>Desarrollamos</strong> <br />
            productos finales <br />
            utilizando <strong>impresoras</strong> <br />
            de bajo costo, <br />
            gracias a <strong>nuestra expertiz</strong> <br />
            en resistencia de materiales <br />
            y métodos <br />
            de impresión.
          </p>
          <img
            :src="productoActualImg(2)"
            alt=""
            v-on:click="(indexdev = 4), (nameIndex = 2)"
            v-on:mouseover="(indexdev = 4), (nameIndex = 2)"
            v-on:mouseout="(indexdev = 0), (nameIndex = 3)"
            v-bind:class="{ 'is-hidden': nameIndex === 0 || nameIndex === 1 }"
          />
        </div>
      </div>

      <!-- Mobile content -->
      <div
        class="columns is-mobile is-hidden-landscape is-hidden-tablet is-paddingless"
      >
        <div class="column is-centered is-paddingless" align="center">
          <div
            class="column is-4-mobile"
            v-bind:class="{
              'is-hidden': nameIndex !== 3
            }"
          >
            <img
              v-on:click="(nameIndex = 0), (indexdev = 5)"
              :src="productoActualImg(0)"
              alt=""
            />
          </div>
          <div
            class="column is-5-mobile"
            v-bind:class="{
              'is-hidden': nameIndex !== 0,
              'is-10-mobile': nameIndex === 0
            }"
          >
            <img
              v-on:click="(nameIndex = 0), (indexdev = 5)"
              :src="productoActualImg(3)"
              alt=""
            />
          </div>
          <div
            class="column is-5-mobile"
            v-bind:class="{
              'is-hidden': nameIndex === 0 || nameIndex === 3,
              'is-8-mobile': nameIndex !== 0
            }"
          >
            <img
              v-on:click="(nameIndex = 0), (indexdev = 5)"
              :src="productoActualImg(6)"
              alt=""
            />
          </div>
          <div
            class="column is-4-mobile"
            v-bind:class="{
              'is-hidden': nameIndex !== 3
            }"
          >
            <img
              v-on:click="(nameIndex = 1), (indexdev = 5)"
              :src="productoActualImg(1)"
              alt=""
            />
          </div>
          <div
            class="column is-5-mobile"
            v-bind:class="{
              'is-hidden': nameIndex !== 1,
              'is-10-mobile': nameIndex === 1
            }"
          >
            <img
              v-on:click="(nameIndex = 1), (indexdev = 5)"
              :src="productoActualImg(4)"
              alt=""
            />
          </div>
          <div
            class="column is-5-mobile"
            v-bind:class="{
              'is-hidden': nameIndex === 1 || nameIndex === 3,
              'is-8-mobile': nameIndex !== 1
            }"
          >
            <img
              v-on:click="(nameIndex = 1), (indexdev = 5)"
              :src="productoActualImg(7)"
              alt=""
            />
          </div>
          <div
            class="column is-4-mobile"
            v-bind:class="{
              'is-hidden': nameIndex !== 3
            }"
          >
            <img
              :src="productoActualImg(2)"
              v-on:click="(nameIndex = 2), (indexdev = 5)"
              alt=""
            />
          </div>
          <div
            class="column is-5-mobile"
            v-bind:class="{
              'is-hidden': nameIndex !== 2,
              'is-10-mobile': nameIndex === 2
            }"
          >
            <img
              v-on:click="(nameIndex = 2), (indexdev = 5)"
              :src="productoActualImg(5)"
              alt=""
            />
          </div>
          <div
            class="column is-5-mobile"
            v-bind:class="{
              'is-hidden': nameIndex === 2 || nameIndex === 3,
              'is-8-mobile': nameIndex !== 2
            }"
          >
            <img
              v-on:click="(nameIndex = 2), (indexdev = 5)"
              :src="productoActualImg(8)"
              alt=""
            />
          </div>
        </div>
        <div
          class="column is-centered position-relative"
          v-on:click="(indexdev = 0), (nameIndex = 3)"
          v-bind:class="{
            'is-hidden': nameIndex === 3
          }"
        >
          <div
            class="column is-paddingless position-devsof-mobile"
            v-bind:class="{
              'is-hidden': nameIndex === 1 || nameIndex === 2 || nameIndex === 3
            }"
            align="center"
          >
            <h2
              class="column is-paddingless is-size-4 has-font-unicone dp-title full-center"
              align="center"
            >
              DESARROLLO <br />
              SOFTWARE
            </h2>
            <p class="orange-background" align="center">
              <strong>
                Creamos <br />
                y mantenemos</strong
              >
              <br />
              herramientas <br />
              que <strong>simplifican</strong> <br />
              los procedimientos <br />
              médicos <br />
              necesarios para <br />
              la fabricación de <br />
              <strong>nuestros productos.</strong>
            </p>
          </div>
          <div
            class="column is-paddingless position-print-mobile"
            v-bind:class="{
              'is-hidden': nameIndex === 0 || nameIndex === 2 || nameIndex === 3
            }"
            align="middle"
          >
            <h2
              class="column is-paddingless is-size-4 has-font-unicone dp-title full-center"
              align="center"
            >
              IMPRESIÓN <br />
              3D
            </h2>
            <p class="orange-background" align="center">
              <strong>Desarrollamos</strong> <br />
              productos finales <br />
              utilizando <br />
              <strong>impresoras</strong> de <br />
              bajo costo, <br />
              gracias a <br />
              <strong>nuestra expertiz</strong> <br />
              en resistencia <br />
              de materiales <br />
              y métodos <br />
              de impresión.
            </p>
          </div>
          <div
            class="column is-paddingless position-testing-mobile"
            v-bind:class="{
              'is-hidden': nameIndex === 0 || nameIndex === 1 || nameIndex === 3
            }"
            align="center"
          >
            <h2
              class="column is-paddingless is-size-4 has-font-unicone dp-title full-center"
              align="center"
            >
              TESTEO DE <br />
              MATERIAL
            </h2>
            <p class="orange-background" align="center">
              <strong>Testeamos</strong> <br />
              nuestros materiales <br />
              <strong>basados</strong> en <br />
              las normas: <br />
              <strong>ASTMD-790</strong> <br />
              de resistencia <br />
              a la <strong>flexión</strong> <br />
              y <strong>ASTMD-7774-17</strong> <br />
              de resistencia <br />
              a la <strong>fatiga.</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImg } from "@/utils/AssetsHelper"

export default {
  methods: {
    getImg,
    productoActualImg(indexProduct) {
      return getImg(this.desarrollo[indexProduct])
    }
  },
  data() {
    return {
      desarrollo: [
        "desarrollo/Circulo-Logo-DesarrolloSoftware.png",
        "desarrollo/Circulo-Logo-Impresion3D.png",
        "desarrollo/Circulo-Logo-TesteoMaterial.png",
        "desarrollo/Circulo-Logo-DesarrolloSoftware-selected.png",
        "desarrollo/Circulo-Logo-Impresion3D-selected.png",
        "desarrollo/Circulo-Logo-TesteoMaterial-selected.png",
        "desarrollo/Circulo-Logo-DesarrolloSoftware-Gris.png",
        "desarrollo/Circulo-Logo-Impresion3D-Gris.png",
        "desarrollo/Circulo-Logo-TesteoMaterial-Gris.png"
      ],
      indexdev: 0,
      nameIndex: 3
    }
  }
}
</script>

<style scoped>
.bottom-absolute {
  position: sticky;
  bottom: 0;
}

.center-absolute {
  position: absolute;
  top: 50%;
}

.dp-title {
  color: #f39e52;
}

.height10 {
  height: 10vh;
}

.height109 {
  height: 100vh;
}

.text-transparent {
  color: transparent;
}

.orange-background {
  background: rgba(243, 158, 82, 0.2);
}

.full-center {
  align-items: center;
  justify-content: center;
}

.position-center {
  position: center;
}

.position-relative {
  position: relative;
}

.position-devsof-mobile {
  position: absolute;
  top: 0;
}

.position-print-mobile {
  position: absolute;
  top: 15%;
}

.position-testing-mobile {
  position: absolute;
  bottom: 0;
}

@media screen and (min-width: 1080px) {
  .title-full-size {
    font-size: 3rem !important;
  }
  .new-back {
    background-image: url("../../assets/img/desarrollo/Ciculo-de-Texto.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}

@media (orientation: landscape) and (min-width: 500px) and (max-width: 1088px) and (max-height: 600px){
  .is-hidden-landscape {
    display: none;
  }
  .display-inline-in-landscape {
    display: inline !important;
  }
  .display-flex-in-landscape {
    display: flex !important;
  }
  .display-inherit-in-landscape {
    display: inherit !important;
  }
}

@media screen and (orientation: portrait) {
  .is-hidden-portrait {
    display: none;
  }
}
</style>
